export const selectCurrentOrder = state => {
  return state.orders.netsuite_purchase_order;
};
